import React, { FC, useEffect, useState } from 'react';
import { fetchBlob } from '../../../utils/fetchBlob';
import { ButtonComponent } from '../../../ReusableComponents/Button/ButtonComponent';
import ModalComponent from '../../../ReusableComponents/Modal/ModalComponent';
import './DeliveryImageModal.scss';
import Swal from 'sweetalert2';

export const DeliveryImageModal: FC<{
  title: string;
  url: string;
  showDeleteButton: boolean;
  onDeleteImage?: () => void;
}> = ({ title, url, showDeleteButton, onDeleteImage }) => {
  const [imageUrl, setImageUrl] = useState<string>();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    (async () => {
      const blob = await fetchBlob(url);
      setImageUrl(URL.createObjectURL(blob));
    })();
  }, []);

  const deleteImage = async () => {
    const securityCheck = await Swal.fire({
      title: 'Confirm deleting delivery image',
      text: 'Are you sure you want to permanently delete this delivery image?',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#0f6474',
      confirmButtonColor: '#dd6c62',
      confirmButtonText: 'Delete',
      focusCancel: true,
    });
    if (securityCheck.isConfirmed) {
      setShowModal(false);
      if (onDeleteImage !== undefined) {
        onDeleteImage();
      }
    }
  };

  return (
    <>
      <ButtonComponent
        variant="outlined"
        color="default"
        onClick={() => setShowModal(true)}
        disabled={imageUrl === undefined}
      >
        Open
      </ButtonComponent>
      <ModalComponent
        title={title}
        open={showModal}
        setOpen={open => setShowModal(open)}
        showCloseButton={true}
        className="delivery-image-modal"
      >
        <div className="delivery-image-modal__content">
          <img src={imageUrl} />
        </div>
        <div className="delivery-image-modal__buttons">
          <ButtonComponent
            variant="outlined"
            color="default"
            disabled={!showDeleteButton}
            onClick={() => deleteImage()}
          >
            Delete Image
          </ButtonComponent>
          <ButtonComponent
            variant="outlined"
            color="primary"
            onClick={() => setShowModal(false)}
          >
            Close
          </ButtonComponent>
        </div>
      </ModalComponent>
    </>
  );
};
